<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Inventario por cliente
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span>Inventario por cliente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" #rutcliente
              formControlName="rutCliente" formatRut />
            <label for="rutcliente">Rut cliente</label>
            <!-- <div *ngIf="
                  formHeader.get('rutCliente').invalid &&
                  (formHeader.get('rutCliente').dirty ||
                  formHeader.get('rutCliente').touched)
              ">
              <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                Ingrese rut cliente
              </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarcliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents" *ngIf=" cliente">
            {{ cliente.razon_social }}
          </h6>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsSucursal" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar sucursal" formControlName="sucursal"></mdb-select>
            <label>Sucursales</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<section *ngIf="showButton" style="z-index: 2;">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 20%;">
    <div class="example-flex-container" style="z-index: 2;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollTop()">
          <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section style="z-index: 3;" *ngIf="showButtonDown">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
    <div class="example-flex-container" style="z-index: 3;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollAbajo()">
          <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>

<div class="card mb-2 wow" *ngIf="listaMaquinas?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('PDF')">
      PDF
    </button>
  </div>
</div>

<section infinite-scroll (scrolled)="onScrollDown($event)" style="z-index: 1;" >
  <div class="card mb-2 wow"  style="z-index: 1;">
    <div class="card-body" *ngIf="listaMaquinas">

      <!-- <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner> -->

      <div class="">

      <table class="table TablePrincipal table-striped table-hover table-sm align-middle"
        mdbTableEditor
        mdbTable
        mdbTableScroll scrollX="true" scrolly="true"
        maxHeight="500" striped="true" bordered="true"
        stickyHeaderBgColor="#E0E0E0"
        stickyHeaderTextColor="#212529"
        stickyHeader="true">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Dirección</th>
              <th scope="col">Comuna</th>
              <th scope="col">Ciudad</th>
              <th scope="col">Ubicación</th>
              <th scope="col">Contacto</th>
              <th scope="col">N° Placa</th>
              <th scope="col">Marca</th>
              <th scope="col" style="width: 75px;">Modelo</th>
              <th scope="col" style="width: 75px;">Estado</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let mov of listaMaquinas">
              <td>{{mov.direccion}}</td>
              <td>{{mov.nombre_comuna}}</td>
              <td>{{mov.nombre_ciudad}}</td>
              <td>{{mov.ubicacion}}</td>
              <td>{{mov.contacto}}</td>
              <td>{{mov.placa}}</td>
              <td>{{mov.marca}}</td>
              <td>{{mov.modelo}}</td>
              <td>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 1" pill="true" success="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 2" pill="true" info="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 3" pill="true" warning="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 4" pill="true" danger="true">{{mov.estado}}</mdb-badge>
              </td>
            </tr>
            <tr>
              <td colspan="100%" style="text-align: center">
                <div class="row pb-1 pt-1" id="spinnerX">
                  <div class="col-md-12 p-4">
                    <ngx-spinner
                    bdColor=""
                    bdoOpacity="0.9"
                    size="default"
                    color="#581f87"
                    type="ball-pulse-sync"
                    [fullScreen]="false"
                    >
                  </ngx-spinner>

                  </div>
               </div>
              </td>

            </tr>
          </tbody>
          <tfoot *ngIf="listaMaquinas?.length > 0">
            <tr>
              <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
              <th colspan="12">
                {{ PagPosActual }} de  {{ totalPagPos }} ({{
                  totalRegistrosPos
                }}
                registros)
              </th>
            </tr>
          </tfoot>
          <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="listaMaquinas?.length > 0"></app-pagination> -->
        </table>
      </div>
    </div>
  </div>
</section>



<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>
